import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
import { Entity } from "@rest-hooks/rest";
export var ValidatorEnumTypes;
(function (ValidatorEnumTypes) {
    ValidatorEnumTypes["NotSet"] = "NotSet";
    ValidatorEnumTypes["Visibility"] = "Visibility";
    // Required = "Required", // Not implemented
    ValidatorEnumTypes["Disabled"] = "Disabled";
})(ValidatorEnumTypes || (ValidatorEnumTypes = {}));
export const ValidatorDescriptions = {
    [ValidatorEnumTypes.NotSet]: {
        description: "",
        shortHelperText: ""
    },
    [ValidatorEnumTypes.Visibility]: {
        description: "Connected fields are visible when the Target field's value",
        shortHelperText: "are visible when",
        defaultOption: "Default visible when conditions are not met?"
    },
    // [ValidatorEnumTypes.Required]: {
    // 	description: "Connected fields are required when the Target field's value",
    // 	shortHelperText: "are required when",
    // 	defaultOption: "Default required when conditions are not met?"
    // },
    [ValidatorEnumTypes.Disabled]: {
        description: "Connected fields are disabled when the Target field's value",
        shortHelperText: "are disabled when",
        defaultOption: "Default disabled when conditions are not met?"
    }
};
class FormValidatorResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.formValidatorId = "";
        this.name = "";
        this.validatorType = ValidatorEnumTypes.NotSet;
        this.errorMessage = "";
        this.changeDate = undefined;
        this.description = undefined;
        this.helperText = undefined;
        this.operator = undefined;
        this.evaluationValue = undefined;
    }
    pk() {
        return this.formValidatorId?.toString();
    }
    static detail() {
        const endpoint = super.detail();
        return endpoint.extend({
            url: urlParams => {
                return endpoint.url(urlParams);
            }
        });
    }
}
FormValidatorResource.urlRoot = apiResourceUrl("form-validator");
export { FormValidatorResource };
class FormValidatorToFormTemplateResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.formValidatorToFormId = "";
        this.formTemplateId = "";
        this.formValidatorId = "";
        this.connectedFields = undefined;
        this.targetField = "";
        this.description = "";
    }
    pk() {
        return this.formValidatorToFormId?.toString();
    }
    static detail() {
        const endpoint = super.detail();
        return endpoint.extend({
            url: urlParams => {
                return endpoint.url(urlParams);
            }
        });
    }
}
FormValidatorToFormTemplateResource.urlRoot = apiResourceUrl("form-validator-to-form-template");
export { FormValidatorToFormTemplateResource };
export class FormValidationExpression extends Entity {
    constructor() {
        super(...arguments);
        this.pk = () => this._owningFieldName;
        this._owningFieldName = "";
        this.evaluationValue = "";
        this.operator = "";
        this.targetField = "";
        this.validatorType = "";
    }
}
class FormValidationResource extends BaseResource {
    pk() {
        return "form-validations_singleton";
    }
    static formValidations() {
        return this.detail().extend({
            url: urlParams => `${this.urlRoot}/get-form-validations/${urlParams}`
        });
    }
}
FormValidationResource.urlRoot = apiResourceUrl("resolve-form-validations");
export { FormValidationResource };
//# sourceMappingURL=FormValidatorResource.js.map